module.exports = require('next/app')
